/* The mockup's `.toolbar`: one wrapping row, the tabs first and the controls pushed to the right. */
.toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2);
  margin-block-end: var(--space-4);
}

.spacer {
  flex: 1;
}
